import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import {
  IconBook,
  IconBuilding,
  IconCalendarEvent,
  IconCash,
  IconChartBar,
  IconCoin,
  IconFileText,
  IconHome,
  IconKey,
  IconNews,
  IconPencil,
  IconShieldLock,
  IconUserPlus,
  IconUsers,
  IconAddressBook,
} from "@tabler/icons-react";
import { Sidebar, SidebarBody, SidebarLink } from "../ui/sidebar";
import { useHasPrivilege } from "../../hooks/usePermissions";

const iconClass = "h-5 w-5 shrink-0 text-neutral-900 dark:text-neutral-200";

const AdminPage = () => {
  const [open, setOpen] = useState(false);
  const [waitingCount, setWaitingCount] = useState(0);
  const hasPrivilege = useHasPrivilege();

  useEffect(() => {
    fetchWaitingCount();
  }, []);

  const fetchWaitingCount = async () => {
    try {
      const response = await fetch("/api/users/waiting/count");
      const data = await response.json();
      setWaitingCount(data.count);
    } catch (error) {
      setWaitingCount(0);
    }
  };

  const links = [
    {
      label: "Ожидающие вступления",
      href: "accept-members",
      icon: <IconUserPlus className={iconClass} />,
      show: hasPrivilege("MANAGE:MEMBERS"),
      badge: waitingCount,
    },
    {
      label: "Члены организации",
      href: "members",
      icon: <IconUsers className={iconClass} />,
      show: hasPrivilege("MANAGE:MEMBERS"),
    },
    {
      label: "Доступы",
      href: "access-management",
      icon: <IconKey className={iconClass} />,
      show: hasPrivilege("MANAGE:ACCESS"),
    },
    {
      label: "Роли",
      href: "roles",
      icon: <IconShieldLock className={iconClass} />,
      show: hasPrivilege("MANAGE:ROLES"),
    },
    {
      label: "Контакты",
      href: "contacts",
      icon: <IconAddressBook className={iconClass} />,
      show: hasPrivilege("MANAGE:CONTACTS"),
    },
    {
      label: "Печать документов",
      href: "print-docs",
      icon: <IconFileText className={iconClass} />,
      show: hasPrivilege("MANAGE:PRINTDOCS"),
    },
    {
      label: "События",
      href: "events",
      icon: <IconCalendarEvent className={iconClass} />,
      show: hasPrivilege("MANAGE:EVENTS"),
    },
    {
      label: "Организации",
      href: "organizations",
      icon: <IconBuilding className={iconClass} />,
      show: hasPrivilege("MANAGE:ORGANIZATIONS"),
    },
    {
      label: "Управление книгами",
      href: "books",
      icon: <IconBook className={iconClass} />,
      show: hasPrivilege("MANAGE:BOOKS"),
    },
    {
      label: "Редактор анонсов",
      href: "news",
      icon: <IconNews className={iconClass} />,
      show: hasPrivilege("MANAGE:NEWS"),
    },
    {
      label: "Редактор статей",
      href: "articles",
      icon: <IconPencil className={iconClass} />,
      show: hasPrivilege("MANAGE:ARTICLES"),
    },
    {
      label: "Взносы",
      href: "contributions",
      icon: <IconCoin className={iconClass} />,
      show: hasPrivilege("MANAGE:FINANCE"),
    },
    {
      label: "Расходы",
      href: "expenses",
      icon: <IconCash className={iconClass} />,
      show: hasPrivilege("MANAGE:FINANCE"),
    },
    {
      label: "Статистические отчеты",
      href: "stat-reports",
      icon: <IconChartBar className={iconClass} />,
      show: hasPrivilege("MANAGE:FINANCE"),
    },
  ];

  return (
    <div className="fixed inset-0 flex w-full flex-col overflow-hidden bg-gray-100 md:flex-row dark:bg-neutral-800">
      <Sidebar open={open} setOpen={setOpen}>
        <SidebarBody className="justify-between gap-10">
          <div className="flex w-full flex-1 flex-col gap-2 overflow-y-auto py-4">
            {links
              .filter((link) => link.show)
              .map((link, idx) => (
                <SidebarLink
                  key={idx}
                  link={{
                    label: (
                      <span className="flex items-center gap-2">
                        <span className="truncate">{link.label}</span>
                        {link.badge > 0 && (
                          <span className="ml-auto inline-flex items-center justify-center rounded-full bg-red-500 min-w-[20px] h-5 px-1 text-xs font-bold text-white">
                            {link.badge}
                          </span>
                        )}
                      </span>
                    ),
                    href: link.href,
                    icon: link.icon,
                  }}
                />
              ))}
          </div>
          <SidebarLink
            link={{
              label: "На сайт",
              href: "/",
              icon: <IconHome className={iconClass} />,
            }}
          />
        </SidebarBody>
      </Sidebar>

      <main className="w-full flex-1 overflow-y-auto bg-white dark:bg-neutral-900">
        <div className="p-4 md:p-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminPage;
